import PaletteFacets from '../search/PaletteFacets'
import { SEARCHROOM_SORTS } from './searchroomFacets'
import './SearchroomFilterPopover.css'

// Extra searchroom filter fields. The Filter header sits above this panel.
function SearchroomFilterPanel({ facets, values, onChange, sort, onSortChange }) {
  return (
    <div className="nav-filter-panel" role="group" aria-label="Filter searchrooms">
      <div className="nav-filter-body">
        <PaletteFacets facets={facets} values={values} onChange={onChange} />
        <div className="sr-filter-sort">
          <span className="palette-facet-label">Sort by</span>
          <select
            className="sr-filter-select"
            value={sort}
            onChange={(event) => onSortChange(event.target.value)}
          >
            {SEARCHROOM_SORTS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default SearchroomFilterPanel
